import { isEcoFoot2Plus, isRM10Evolution, isRM5, isRmGridflex10D } from "__common/constants/products";
import { MAX_BLOCK_COUNTS, rmGridflex10MaxBlockNorthCornerCount } from "../utils/constants";

export const apiField = 'max_block_north_corner_count';

interface MaxBlockCountField {
  type: string;
  apiField: string;
  missing?: any;
  label: string;
  tooltip: () => string;
  data?: MaxBlockCountFieldOption[];
  min: number;
  max: number;
  step?: number;
}

interface MaxBlockCountFieldOption {
  value: string;
  name: string;
}

function makeConfig(max: number = 4, label: string = 'Max Block North Corner Count', min : number = 0.5, step: number = 1): MaxBlockCountField {  
  return {
    type: 'Number',
    label,
    apiField,
    tooltip: undefined,
    min,
    max,
    missing:undefined,
    step,
  };
}

export const getMaxBlockNorthCornerCountField = (productId, lowerLimit, half_block_allowed?, fully_attached?, module_length?) => {
  let upperLimit;
  let label;
  let stepIncrement = half_block_allowed ?  0.5 : 1;
  if(isRM10Evolution(productId) || isEcoFoot2Plus(productId)){
    upperLimit = MAX_BLOCK_COUNTS[productId]
    label = "northBayCapacity";
  }
  else if(isRM5(productId) || isRmGridflex10D(productId)){
    upperLimit = rmGridflex10MaxBlockNorthCornerCount(half_block_allowed, module_length)
    label = "maxBlockNorthCornerCount";
  }
  if(lowerLimit >= upperLimit){
    lowerLimit = upperLimit
    stepIncrement = 0
  }
  return makeConfig(upperLimit, label, lowerLimit+stepIncrement, stepIncrement);
};


